
import { Route, Routes } from 'react-router-dom';

import { ToastContainer } from 'react-toastify';
import { initCustomAlerts } from './helpers/alertError';

import AdminNav from './navigation/profile-nav/AdminNav';
import NotFoundPage from './pages/public/NotFoundPage';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import Redirect from './pages/auth/RedirectPage';
import ConfirmationPage from './pages/auth/ConfirmationPage';
import ShopNav from './navigation/profile-nav/ShopNav';
import ProtectedRoute from './wrappers/auth/ProtectedRoute';


function App() {

  // Initialiser le remplacement des alerts
  initCustomAlerts();

  return (

    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/redirect" element={<Redirect />} />
        <Route path="/confirm/:token" element={<ConfirmationPage />} />

        <Route path="/admin/*" element={<ProtectedRoute allowedRoles={["admin"]}>
          <AdminNav />
        </ProtectedRoute>} />
        <Route path="/shop/*" element={<ProtectedRoute allowedRoles={["admin" , "shop"]}>
          <ShopNav />
        </ProtectedRoute>} />

        <Route path="*" element={<NotFoundPage />} />


      </Routes>

    </>
  );
}

export default App;
